/**
 * 查看培训记录
 * @author xyguo
 * @date 2021-3-16
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizModal, WizComponent, WizForm, WizCheckbox, WizRow, WizCol, WizSpin, WizButton } = component_tool;
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { $$, checkStrLength } = utils_tool;
import '../../../../styles/containers/train/path/requirement/style.less'
class RealTrain extends WizContainer {

  componentName = 'RealTrain';

  constructor(props) {
    super(props)
    let { record ,reportType} = props
    this.state = {
      record,
      dataDetail:{},
      reportType,
      timestamp: new Date().getTime()
    }
  }

  _componentDidMount() {
    if(this.state.record && this.state.record.id){
      this._getInfo();
    }
  }

  _getInfo() {
    let {record,reportType} = this.state
    this.doAction({
      path: 'requirementOrgPerson/getInfo',
      payload: {
        key: 'requirementOrgPerson@getInfo'+record.id+'@'+reportType,
        apiParams: {id: record['id'],reportType:reportType}
      },
    })
  }

  propsAndStateOnChange = {
    getInfo: this._getInfoOver.bind(this),
  };

  _getInfoOver(nextProps, nextState) {
    let { getInfo } = nextProps
    if (getInfo['success']) {
        nextState['dataDetail'] = getInfo.data
        return true;
    } else {
        wizNotice.error(getInfo['msg'] || '获取数据失败，请稍后再试')
    }
    return false;
}

  _rowViewHead(title, value) {
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={10}>{title}</WizCol>
        <WizCol offset={2} span={10}>{value}</WizCol>
      </WizRow>
    )
  }

  _rowViewBody(titleA, valueA,titleB,valueB) {
    let showA = titleA && valueA ? ":":""
    let showB = titleB && valueB ? ":":""
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={5}> {titleA}{showA}</WizCol>
        <WizCol span={3}>{valueA}</WizCol>
        <WizCol offset={1} span={3}>{titleB}{showB}</WizCol>
        <WizCol offset={0} span={10}>{valueB}</WizCol>
      </WizRow>
    )
  }

  _rowViewTail(title, value) {
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={5}>{title}:</WizCol>
        <WizCol span={17}>{value}</WizCol>
      </WizRow>
    )
  }

  _rowTitleView(title) {
    return (
      <WizRow className="look-row">
        <WizCol span={20} offset={1} ><strong>{title}</strong></WizCol>
      </WizRow>
    )
  }

  _getContentName(type){
    let contentNameObj =
      {0:"路径名称",
      1:"认证名称",
      2:"课程名称",
      // 3:"人员测评",
      // 4:"标杆店实践",
      // 5:"个人简历",
      // 6:"性格测试",
      // 7:"面试结果",
      // 8:"电工证",
      // 9:"岗位认证",
      10:"考试名称",
      11:"完成情况"}
      return contentNameObj[type]
  }

  _personInfo(dataDetail){
    return  <div className="menu-item item-title">
      {this._rowTitleView('学员基本信息')}
      {this._rowViewHead('姓名：'+dataDetail.fullName, '账号：'+dataDetail.userName)}
      {this._rowViewHead('岗位：'+dataDetail.positionName, '状态：'+dataDetail.jobStateStr)}
      </div>;
  }

  _trainInfo(dataDetail){
    let returnInfo = []
    if(dataDetail.allShowContentMap && Object.keys(dataDetail.allShowContentMap).length){
      Object.keys(dataDetail.allShowContentMap).forEach(key => {
        const value = dataDetail.allShowContentMap[key];
        if (value != null && value != undefined) {
          let {showTitle,contentState,entity} = value
          let entityName = entity && entity.entityName
          if(entity && entity.onlineCourseFinishRate){
            entityName = entity.onlineCourseFinishRate
          }
          let entityTypeName = this._getContentName(key);
          let rowViewBody = this._rowViewBody(showTitle,contentState,entityTypeName,entityName)
          returnInfo.push(rowViewBody);
        }
      })
    }else{
      let rowViewBody = this._rowViewBody("本岗位暂无考核要求",undefined,undefined,undefined)
      returnInfo.push(rowViewBody)
    }
    return  <div className="menu-item">
      {this._rowTitleView('学员培训情况')}
      {returnInfo}
      </div>;
  }

  _dpInfo(dataDetail){
    console.log("dataDetail==",dataDetail)
    let operateType = "";
    if(dataDetail.operateType == 1){
      operateType = "人工"
    }else if(dataDetail.operateType == 2){
      operateType = "系统"
    }
    if(this.state.reportType){
      return  <div className="menu-item">
      {this._rowTitleView('DP状态')}
      {this._rowViewTail('DP状态',dataDetail.trainDpStatusStr)}
      {this._rowViewTail('DP状态操作人',dataDetail.operatorFullName)}
      {this._rowViewTail('DP状态操作类型',operateType)}
      {this._rowViewTail('备注',dataDetail.remark)}
      </div>;
    }
  }


  render() {
    const { requirementOrgPersonLoading } = this.props;
    let { record, timestamp,dataDetail } = this.state
    return <div className="realTrain" key={timestamp}>
        {this._personInfo(dataDetail)}
        {this._trainInfo(dataDetail)}
        {this._dpInfo(dataDetail)}
      </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { requirementOrgPerson } = state;
  const getInfo = modelUtils.getModelEntity(requirementOrgPerson, 'requirementOrgPerson@getInfo'+ownProps.record.id+'@'+ownProps.reportType);
  const load = modelUtils.getLoadingState(state, "requirementOrgPerson");
  return {
    getInfo,
    ...load,
  };
};
const options = { withRef: true };
export default connect(mapStateToProps, null, null, options)(RealTrain);
